import { acMesh } from "../products/acMesh";
import { acMeshProfessional } from "../products/acMeshProfessional";
import { baseStationXG } from "../products/baseStationXG";
// import { baseStationXG } from "../products/baseStationXG";
import { e7 } from "../products/e7";
import { e7Audience } from "../products/e7Audience";
// import { e7AudienceMegaCapacity } from "../products/e7Audience-megaCapacity";
import { e7Campus } from "../products/e7Campus";
import { u7proOutdoorOverviewVariant } from "../products/overview-variants/u7proOutdoorOverviewVariant";
import { swissArmyKnifeUltra } from "../products/swissArmyKnifeUltra";
import { u6enterprise } from "../products/u6enterprise";
import { u6EnterpriseInWall } from "../products/u6EnterpriseInWall";
import { u6Extender } from "../products/u6Extender";
import { u6InWall } from "../products/u6InWall";
import { u6lr } from "../products/u6lr";
import { u6Mesh } from "../products/u6Mesh";
import { u6MeshPro } from "../products/u6MeshPro";
import { u6plus } from "../products/u6plus";
import { u6pro } from "../products/u6pro";
import { u7InWall } from "../products/u7InWall";
import { u7lite } from "../products/u7Lite";
import { u7lr } from "../products/u7lr";
import { u7outdoor } from "../products/u7outdoor";
import { u7pro } from "../products/u7pro";
import { u7proMax } from "../products/u7proMax";
import { u7proWall } from "../products/u7ProWall";
import { u7proXg } from "../products/u7proXg";
import { u7proXgs } from "../products/u7proXgs";

export const wifiProducts = [
  /** Enterprise */
  e7,
  e7Campus,
  e7Audience,
  /** Flagship */
  u7proXgs,
  u7proXg,
  u7proMax,
  u7pro,
  u7lr,
  u7lite,
  u6enterprise,
  u6pro,
  u6lr,
  u6plus,
  /** In-Wall */
  u7proWall,
  u6EnterpriseInWall,
  u7InWall,
  u6InWall,
  u6Extender,
  /** Outdoor */
  u7proOutdoorOverviewVariant,
  u7outdoor,
  u6MeshPro,
  u6Mesh,
  acMeshProfessional,
  acMesh,
  swissArmyKnifeUltra,
  baseStationXG,
  /** June 5th, 2025 request to remove
   * Mega Capacity from overview
   */
  // e7AudienceMegaCapacity,
  // baseStationXG,
];
